import React from 'react';

import { Group, Stack, Switch, Text, Title } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { FormValues } from './DrawerDiscountForm';

interface IAvailabilitySettingsSectionProps {
  form: UseFormReturnType<FormValues, (values: FormValues) => unknown>;
  disabled?: boolean;
}

const AvailabilitySettingsSection = ({
  form,
  disabled = false,
}: IAvailabilitySettingsSectionProps): JSX.Element => {
  return (
    <Stack>
      <Title order={3}>3. Availability Settings</Title>
      <Group noWrap align='flex-start' position='apart'>
        <Stack spacing='0'>
          <Group spacing='xs'>
            <Text size='lg'>Status:</Text>
            <Text size='lg' color={form.values.isActive ? 'green' : 'gray'}>
              {form.values.isActive ? 'Active' : 'Inactive'}
            </Text>
          </Group>
          <Text size='xs' color='gray'>
            {form.values.isActive
              ? 'This discount can be applied by athletes and staff'
              : 'This discount cannot be applied'}
          </Text>
        </Stack>
        <Switch {...form.getInputProps('isActive', { type: 'checkbox' })} disabled={disabled} />
      </Group>
      <Group noWrap align='flex-start' position='apart'>
        <Stack spacing='0'>
          <Text size='lg'>One-Time Use</Text>
          <Text size='xs' color={form.values.isOneTimeUse ? 'gray' : 'red'}>
            {form.values.isOneTimeUse
              ? 'This discount can only be applied once per athlete.'
              : 'Athletes can redeem this code multiple times. Use caution when distributing.'}
          </Text>
        </Stack>
        <Switch {...form.getInputProps('isOneTimeUse', { type: 'checkbox' })} disabled={disabled} />
      </Group>
    </Stack>
  );
};

export default AvailabilitySettingsSection;
